import React, { Fragment, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu, Typography } from 'antd';
import { formatPhoneNumber } from '../../helpers/formatPhoneNumber';
import useSipStates from '../../hooks/useSipStates';
import { SipPhoneContext } from '../SipPhoneProvider';
import {
  setCallDirection,
  setIsControlPanelVisible,
  setPhoneFieldValue,
  setSubscriber,
} from '../../containers/Phone/store/actions';
import { callDirections } from '../../containers/Phone/constants/callDirections';
import { isControlPanelVisibleSelector } from '../../containers/Phone/store/selectors';
import styles from './PhoneNumber.module.scss';
import cn from 'classnames';
import { PhoneNumberIcon } from './PhoneNumberIcon';

const { Text } = Typography;

const dispatcherDispexValue = 'Own';

const SimplePhoneNumber = ({ phoneNumber, className, ...props }) => (
  <Text {...props} className={className}>
    {phoneNumber || ''}
  </Text>
);

const ActionPhoneNumber = ({
  phoneNumber,
  name,
  className,
  style,
  getPopupContainer = () => document.body,
}) => {
  const { startCall } = useContext(SipPhoneContext);

  const dispatcher = useSelector(
    (state) => state.authentication.userInfo.Dispatcher
  );

  const isDispetcherDispex = dispatcher === dispatcherDispexValue;

  const dispatch = useDispatch();

  const isControlPanelVisible = useSelector(isControlPanelVisibleSelector);

  const handleClick = ({ key }) => {
    if (key === 'call') {
      if (!isControlPanelVisible) {
        dispatch(setIsControlPanelVisible(true));
      }

      dispatch(setCallDirection(callDirections.outgoing));

      const subscriber = { phone: phoneNumber };

      if (name) {
        subscriber.serviceCompany = name;
      }

      if (isDispetcherDispex) {
        dispatch(setPhoneFieldValue(phoneNumber));
      } else {
        dispatch(setSubscriber(subscriber));

        startCall(formatPhoneNumber({ phoneNumber }));
      }
    }
  };

  const menu = (
    <Menu onClick={handleClick}>
      <Menu.Item key="call">Позвонить</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} getPopupContainer={getPopupContainer}>
      <SimplePhoneNumber
        phoneNumber={phoneNumber}
        className={className}
        style={{ ...style, cursor: 'pointer' }}
      />
    </Dropdown>
  );
};

const PhoneNumber = ({
  phoneNumber,
  format = '(xxx) xxx-xx-xx',
  withCode,
  placeholder = 'x',
  className,
  getPopupContainer,
  name,
  style,
  isIcon,
}) => {
  const { isConnected, isIdle } = useSipStates();

  const isPossibleToCall = isConnected && isIdle;

  const props = {
    phoneNumber: formatPhoneNumber({
      phoneNumber,
      format,
      withCode,
      placeholder,
    }),
    className,
    style,
  };

  return isPossibleToCall ? (
    <span className={cn(isIcon && styles.phone)}>
      {isIcon && <PhoneNumberIcon isCanCall />}
      <ActionPhoneNumber
        {...props}
        getPopupContainer={getPopupContainer}
        name={name}
      />
    </span>
  ) : (
    <span className={cn(isIcon && styles.phone)}>
      {isIcon && <PhoneNumberIcon isCanCall={false} />}
      <SimplePhoneNumber {...props} />
    </span>
  );
};

export default PhoneNumber;
